import React from 'react'
import { MegabarTransport } from '../../../transports/common/megabar-transport'
import { useTranslation } from '../../../hooks/locale'
import {
    MegaBarContainer,
    MegaDropdownContainer,
    CountryTrigger,
    CountryDropdown,
    CountryName,
    SeoHref,
    ArrowIcon,
    RegionsList,
    RegionItem,
    DropdownRegionHeading,
} from './styles'

interface MegaBarProps {
    megabar: MegabarTransport
}

const MegaBar: React.FC<MegaBarProps> = ({ megabar }) => {
    const { t } = useTranslation()
    return (
        <MegaBarContainer>
            {megabar.countries.map(country => (
                <MegaDropdownContainer key={`${country.name}`}>
                    <CountryTrigger>
                        <SeoHref href={country.link}>
                            <CountryName>{country.name}</CountryName>
                        </SeoHref>
                        <ArrowIcon />
                    </CountryTrigger>

                    <CountryDropdown>
                        <DropdownRegionHeading>{t('popularPlaces')}</DropdownRegionHeading>
                        <RegionsList>
                            {country.regions.map(region => (
                                <SeoHref key={region.name} href={region.link}>
                                    <RegionItem>{region.name}</RegionItem>
                                </SeoHref>
                            ))}
                        </RegionsList>
                    </CountryDropdown>
                </MegaDropdownContainer>
            ))}
        </MegaBarContainer>
    )
}

export default React.memo(MegaBar)
